export default __webpack_public_path__ + "static/media/digi4.666002dd.png";